import CreateSeedAudiencesModalSection from './CreateSeedAudiencesModalSection';

export default CreateSeedAudiencesModalSection;
